import ScheduleBlock from "./dataSection/scheduleBlock";
import WeatherWidget from "./dataSection/weatherWidget";
import GoogleMapCard from "./dataSection/googleMapCard";
import FeteDuJour from "./dataSection/feteDuJour";
import "../../styles/accueil/style_dataSection.css";

export default function DataSection({ data }) {
  return (
    <div id="horaire" className="block-bas">
      <h2 className="titre-bas-n1">L'Instant</h2>
      <h2 className="titre-bas-n2">Floral</h2>

      <ScheduleBlock dataSchedule={data.openning_calendar} /> 
      <div className="container_data_right">
        <WeatherWidget />
        <GoogleMapCard googleMapLink={data.extras.google_map_link}/>
      </div>
      <FeteDuJour partyOfTheDay={data.extras.partyOfTheDay}/>
    </div>
  );
}
